// extracted by mini-css-extract-plugin
module.exports = {"pintxo-skeleton":"Skeleton_pintxo-skeleton__ICZTs","pintxo-skeleton-shape":"Skeleton_pintxo-skeleton-shape__QTTJV","fill-animation":"Skeleton_fill-animation__1vPht"};